import { render } from "./payment-error.vue?vue&type=template&id=1250663e&scoped=true"
import script from "./payment-error.vue?vue&type=script&lang=js"
export * from "./payment-error.vue?vue&type=script&lang=js"

import "./payment-error.vue?vue&type=style&index=0&id=1250663e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1250663e"]])

export default __exports__